<template>
  <div class="ShowGroupManage">
    <van-nav-bar title="群管理员" fixed @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="image">
      <img src="../../assets/manage.png" alt />
      <p>群管理员</p>
    </div>
    <div class="test">
      <p>群管理员可以拥有以下能力</p>
      <ul>
        <li>删除群信息</li>
        <li>查看群管理员</li>
        <li>查看群成员，邀请朋友，删除群成员</li>
      </ul>
    </div>
    <div class="manage">
      <div v-for="(item,index) in groupManage" :key="index" class="member">
        <img :src="attach_url+item.users.u_headportrait" alt />
        <p>{{item.users.ug_group_nick?item.users.ug_group_nick:item.users.u_nickname?item.users.u_nickname:item.users.u_login_id}}</p>
      </div>
      <div v-if="group_manage == 0">
      <img class="add" src="../../assets/img/center/add.png"  @click="addManage(ug_id)" alt />
      <img class="delate" src="../../assets/img/center/delate.png" @click="delManage(ug_id)" alt />
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ShowGroupManage",
  data() {
    return {
      ug_id: "",
      groupManage: "",
      checked: false,
      data: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre,
      group_manage: localStorage.getItem("group_manage"),
    };
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.loadData();
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    loadData() {
      var params = {
        ug_group_id: this.ug_id,
        token: this.token,
        u_id: this.u_id,
        num: Math.random()
      };
      var url = this.Conf.serverUrl + "Groups/getGroupManageUserInfo";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          console.log("show", response);
          if (response.data.code == 200) {
            // this.groupManage = response.data.data[0].users;
            this.groupManage = response.data.data;
            //  console.log("hhhh",this.groupManage )
          }
        })
        .catch(error => {});
    },
    addManage(ug_id) {
      this.$router.push({
        name: "AddGroupManage",
        query: {
          ug_id: ug_id
        }
      });
    },
    delManage(ug_id) {
         this.$router.push({
        name: "DelGroupManage",
        query: {
          ug_id: ug_id
        }
      });
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "GroupChatSet",
        query: {
          ug_id: this.ug_id
        }
      });
    }
  }
};
</script>
<style  lang="less" scoped>
.ShowGroupManage {
  background-color: #fff;
  height: 680px;
  .image {
    padding-top: 80px;
    img {
      width: 80px;
      height: 80px;
    }
  }
  .test {
    margin-top: 20px;
    text-align: left;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 14px;
    color: #b3adad;
    border-bottom: 1px solid #b3adad;
    padding-bottom: 30px;
    ul {
      list-style-type: disc;
      padding-left: 15px;
    }
  }
  .manage {
    padding-top: 30px;
    text-align: left;
    margin-left: 20px;
    display: flex;
    // justify-content: space-between;
    margin-right: 20px;
    flex-wrap: wrap;//溢出则换行
    // align-content: flex-start;
    // justify-content: flex-start;
    flex-direction: row;//主轴的排列方向，水平
    // margin-bottom:20px;
    align-content: space-around;
    img {
      height: 45px;
      width: 45px;
      // margin-left:20px;
    }
    .add{
      margin-left: 20px;
    }
    .delate{margin-left: 30px;}
    .member {
      width: 60px;
      height: 80px;
      margin-left:20px;
      img{
        border-radius:50%;
      }
      p {
        word-break: break-all;
        font-size: 12px;
        color: #b3adad;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Group/ShowGroupManage.vue